import { render, staticRenderFns } from "./ActionsToDo.vue?vue&type=template&id=3735f824&"
import script from "./ActionsToDo.vue?vue&type=script&lang=js&"
export * from "./ActionsToDo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports